import React from 'react';
import pluralize from 'pluralize';
import { AudioFile } from '../../types';
import { useTutorial } from '../../hooks/useTutorial';
import TutorialManager from '../tutorial/TutorialManager';
import { emptyDashboardTutorial } from '../tutorial/tutorials/EmptyDashboardTutorial';

interface WelcomeViewProps {
  allFiles: AudioFile[];
}

const WelcomeView: React.FC<WelcomeViewProps> = ({ allFiles }) => {
  // Trigger tutorial when dashboard is empty
  useTutorial({
    tutorialId: 'empty-dashboard',
    trigger: allFiles.length === 0,
    delay: 1000,
  });

  return (
    <>
      <div className="text-center py-8 md:py-12 px-4">
        <div className="max-w-md mx-auto">
          <h2 className="text-xl md:text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-3 md:mb-4">
            Welcome to VeriVox
          </h2>
          <p className="text-sm md:text-base text-gray-600 dark:text-gray-400 mb-4 md:mb-6">
            Upload audio or video files to get started with transcription.
          </p>
          <div className="text-xs md:text-sm text-gray-500 dark:text-gray-400">
            {allFiles.length > 0 ? (
              <p>
                {pluralize('file', allFiles.length, true)} available. Select a
                file to view its transcript.
              </p>
            ) : (
              <p>
                Create a folder or upload files to the root directory to get
                started.
              </p>
            )}
          </div>
        </div>
      </div>

      <TutorialManager tutorials={[emptyDashboardTutorial]} />
    </>
  );
};

export default WelcomeView;
